import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_TEMPLATE_NAME_EN,
	SET_ACTIVITY_POST_DESCRIPTION_EN,
	SET_ACTIVITY_DESCRIPTION_EN,
	SELECT_ACTIVITY_CHOICE_EN,
	SET_ACTIVITY_NAME_EN,
	SET_ACTIVITY_GOODDEAL_DESCRIPTION_EN,
	SET_ACTIVITY_GOODDEAL_POST_DESCRIPTION_EN
} from "actions/types";

class Step3_Activities extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const {
			dispatch,
			lang,
			choices,
			choiceId,
			descriptionEn,
			postDescriptionEn,
			nameEn,
			gooddealDescriptionEn,
			gooddealPostDescriptionEn
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				{!choices && (
					<Grid item xs={12}>
						<MDInput
							label="Nom"
							id="name-en"
							fullWidth
							value={lang?.en?.name || ""}
							onChange={e =>
								dispatch({
									type: SET_TEMPLATE_NAME_EN,
									payload: e.target.value
								})
							}
						/>
					</Grid>
				)}
				{choices && (
					<Grid item xs={12}>
						<FormSelect
							label="Sélectionner le choix à mettre à jour"
							value={choiceId}
							placeholder="Choix"
							options={Object.values(choices).map(({ name }) => ({
								value: name,
								label: name
							}))}
							onChange={e =>
								dispatch({
									type: SELECT_ACTIVITY_CHOICE_EN,
									payload: e.target.value
								})
							}
						/>
					</Grid>
				)}
				{choices && (
					<Grid item xs={12}>
						<MDInput
							label="Nom"
							id="set-name-en"
							fullWidth
							value={nameEn || ""}
							onChange={e =>
								dispatch({
									type: SET_ACTIVITY_NAME_EN,
									payload: e.target.value
								})
							}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<MDInput
						label="Description"
						id="description-en"
						fullWidth
						multiline
						rows={5}
						value={(choices ? descriptionEn : lang?.en?.description) || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description après photo"
						id="post-description-en"
						fullWidth
						multiline
						rows={3}
						value={
							(choices ? postDescriptionEn : lang?.en?.postDescription) || ""
						}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_POST_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description pour les annonces"
						id="gooddeal-description-en"
						fullWidth
						multiline
						rows={5}
						value={gooddealDescriptionEn || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_GOODDEAL_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description après photo pour les annonces"
						id="gooddeal-post-description-en"
						fullWidth
						multiline
						rows={3}
						value={gooddealPostDescriptionEn || ""}
						onChange={e =>
							dispatch({
								type: SET_ACTIVITY_GOODDEAL_POST_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		name,
		choices,
		choiceId,
		descriptionEn,
		postDescriptionEn,
		lang,
		nameEn,
		gooddealDescriptionEn,
		gooddealPostDescriptionEn
	} = state.templateReducer;

	return {
		name,
		choices,
		choiceId,
		descriptionEn,
		postDescriptionEn,
		lang,
		nameEn,
		gooddealDescriptionEn,
		gooddealPostDescriptionEn
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step3_Activities
);
